import { type AnchorHTMLAttributes, type MouseEvent, type ReactNode } from 'react'
import { scrollToHash } from '../lib/smoothScroll'

type SmoothAnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string
  children: ReactNode
}

export function SmoothAnchor({ href, children, onClick, ...rest }: SmoothAnchorProps) {
  function handleClick(e: MouseEvent<HTMLAnchorElement>) {
    if (href.startsWith('#')) {
      e.preventDefault()
      scrollToHash(href)
    }
    onClick?.(e)
  }

  return (
    <a href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  )
}
